import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Home from "./pages/home";
import NotFound from "./pages/not-found";
import PublicURL from "./pages/public-url";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/layout/Layout";
import InboundMain from "./components/analytics/inbound/InboundMain";
import CdrMain from "./components/cdr/CdrMain";
import OutboundMain from "./components/analytics/outbound/OutboundMain";
import UsersAndPermissionsMain from "./components/management/UsersAndPermissionsMain";
import ApiMain from "./components/apiRest/ApiMain";
import ComingSoon from "./components/shared/ComingSoon";
import LoginPage from "./pages/login";
import RealtimeMain from "./components/realtimev2/RealtimeMain";

// Componente para rutas protegidas
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("krakenT");

  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
};

// Hook para actualizar el título dinámicamente
const useDocumentTitle = (defaultTitle) => {
  const location = useLocation();

  useEffect(() => {
    const routeTitles = {
      "/analytics/inbound": "Inbound",
      "/analytics/outbound": "Outbound",
      "/cdr": "CDR",
      "/login": "Login",
      "/monitor": "Realtime Monitor",
      "/management/api": "API",
      "/management/users": "Users And Permissions",
      // Agrega más rutas y títulos aquí
    };

    const titleSuffix = routeTitles[location.pathname] || defaultTitle;
    document.title = `Insights | ${titleSuffix}`;
  }, [location, defaultTitle]);
};

function App() {
  // Llama al hook personalizado para manejar el título
  useDocumentTitle("Dashboard");

  return (
    <ThemeProvider>
      <Routes>
        {/* Ruta inicial redirige a /analytics/inbound */}
        <Route path="/" element={<Navigate to="/analytics/inbound" />} />

        {/* Rutas públicas */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/shared/outbound" element={<PublicURL />} />

        {/* Rutas protegidas */}
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="inbound" element={<InboundMain />} />
          <Route path="outbound" element={<OutboundMain />} />
        </Route>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="cdr" element={<CdrMain />} />
          <Route path="monitor" element={<RealtimeMain />} />
        </Route>

        <Route
          path="/management"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="users" element={<UsersAndPermissionsMain />} />
          <Route path="api" element={<ApiMain />} />
        </Route>
        {/* Ruta para 404 */}
        <Route
          path="*"
          element={<Navigate to="/analytics/inbound" replace />}
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
